import React, { ComponentType } from 'react';
import { StyleSheet } from 'react-native';
import {
  CellProps,
  isStringControl,
  JsonFormsCellRendererRegistryEntry,
  RankedTester,
  rankWith,
} from '@jsonforms/core';
import { withJsonFormsCellProps } from '@jsonforms/react';
import { FloatingLabelInput } from 'react-native-floating-label-input';
import Colors from '../../../../constants/Colors';
import { RENDERER_RANK_DEFAULT_FALLBACK } from '../constants';

const styles = StyleSheet.create({
  inputContainer: {
    borderWidth: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    width: 100,
    overflow: 'hidden',
    marginTop: 8,
  },
  input: {
    color: Colors.veryDarkGray,
    fontSize: 16,
    fontFamily: 'roboto-regular',
    borderBottomWidth: 1,
    paddingBottom: 4,
    borderBottomColor: Colors.grayBorder,
  },
  errorInput: {
    borderBottomColor: Colors.brightRed,
  },
});

/**
 * Tester to determine if a control can be used with this cell.
 */
const tester: RankedTester = rankWith(
  RENDERER_RANK_DEFAULT_FALLBACK,
  isStringControl // built-in matcher for anything that accepts string input
);

/**
 * Base cell renderer to show a text input control.
 * @param props Control props to be hydrated using `withJsonFormsCellProps`.
 */
const TextCellRenderer: ComponentType<CellProps> = (props: CellProps) => {
  return (
    <FloatingLabelInput
      testID={`TextCell-${props.id}`}
      label={
        // don't float the label, instead just show a static label
        ''
      }
      containerStyles={styles.inputContainer}
      inputStyles={{
        ...styles.input,
        ...(props.errors.length > 0 ? styles.errorInput : {}),
      }}
      onChangeText={(text: string) => props.handleChange(props.path, text)}
      value={props.data ?? ''}
    />
  );
};

/**
 * Renderer registry entry for text input control.
 * Bundles the tester and the wrapped control for use with form.
 */
export const TextCell: JsonFormsCellRendererRegistryEntry = {
  tester,
  cell: withJsonFormsCellProps(TextCellRenderer),
};
